import { EventDescriptionFormat } from '../types';
import { htmlToText, sanitizeEventDescriptionHTML } from '../utils/sanitizeHtml';

type EventDescriptionProps = {
  description: string;
  format?: EventDescriptionFormat;
  compact?: boolean;
};

const EventDescription = ({
  description,
  format = 'plain',
  compact = false,
}: EventDescriptionProps) => {
  if (format !== 'html') {
    return <p className="text-white-50 mb-0">{description}</p>;
  }

  if (compact) {
    return <p className="text-white-50 mb-0">{htmlToText(description)}</p>;
  }

  return (
    <div
      className="event-description-rich text-white-50"
      dangerouslySetInnerHTML={{ __html: sanitizeEventDescriptionHTML(description) }}
    />
  );
};

export default EventDescription;
